import { createTheme } from "@mui/material/styles";
export const BASE_UNIT = 4;
export const baseTheme = createTheme({ spacing: BASE_UNIT });
